import React from "react";
import { howItWorks } from "../../mock";
import Reveal from "../Reveal";

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-ink py-20 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-2xl mx-auto">
          <h2 className="font-display text-3xl sm:text-4xl text-white">{howItWorks.title}</h2>
          <p className="mt-4 text-lg text-white/60">{howItWorks.subtitle}</p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {howItWorks.steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 80}>
              <div className="relative h-full rounded-2xl border border-white/10 bg-ink-soft p-7 hover:border-gold/50 transition-colors">
                <span className="grid place-items-center h-12 w-12 rounded-full bg-gold text-ink font-display text-xl font-700">
                  {s.n}
                </span>
                <h3 className="mt-5 font-display text-lg text-white">{s.title}</h3>
                <p className="mt-2 text-[15px] text-white/60 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
